import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Flex, Link, Typography } from '@coolblue-development/freddy';
import clickAccountCreationIntentionButtonTrigger from '@coolblue-development/ga4-events/triggers/Login/clickAccountCreationIntentionButtonTrigger';
import clickLoginIntentionButtonTrigger from '@coolblue-development/ga4-events/triggers/Login/clickLoginIntentionButtonTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { useTranslation } from '../../../i18n/useTranslation.js';
function Login({ url }) {
    const { t } = useTranslation('account');
    const { trackEvent } = useAnalytics();
    return (_jsxs(Box, { mt: 400, children: [_jsx(Button, { variant: "action", fullWidth: true, component: "a", href: url, onClick: () => trackEvent(clickLoginIntentionButtonTrigger({ sub_feature: 'header' })), children: t('login') }), _jsxs(Flex, { columnGap: 100, mt: 200, children: [_jsx(Typography, { mb: 0, children: t('noAccount') }), _jsx(Link, { href: url, onClick: () => trackEvent(clickAccountCreationIntentionButtonTrigger({
                            sub_feature: 'header',
                            content: 'create_account',
                        })), children: t('startHere') })] })] }));
}
export default Login;
//# sourceMappingURL=Login.js.map